import { useTranslation } from "next-i18next";
import { useCallback } from "react";

import { useSnackbar } from "@/features/common/hooks/snackbar/useSnackbar";
import { useNftContext } from "@/features/nft/hooks/useNft";
import { useUserContext } from "@/features/user/contexts/useUserContext";

export const useWalletValidation = () => {
  const { user } = useUserContext();
  const { activeAccount, connectOrOnBoard, isSameWallet, isSameNetwork } =
    useNftContext();

  const { openSnackbar } = useSnackbar();
  const { t } = useTranslation("common");
  const isValid = useCallback(
    (showSnackbarOnly = false) => {
      // check if user connected to wallet, under same network, using same wallet
      if (!activeAccount)
        return showSnackbarOnly
          ? openSnackbar({
              message: t("common:nft.rejectConnect"),
              severity: "error",
            })
          : connectOrOnBoard();

      if (!isSameNetwork) {
        return openSnackbar({
          message: t("common:nft.networkMismatch"),
          severity: "error",
        });
      }

      if (!isSameWallet) {
        return openSnackbar({
          message: t("common:nft.pleaseSwitchWallet", {
            walletAccount: user.walletAccount,
          }),
          severity: "error",
        });
      }
      return true;
    },
    [
      activeAccount,
      isSameNetwork,
      isSameWallet,
      t,
      connectOrOnBoard,
      openSnackbar,
      user?.walletAccount,
    ],
  );

  return isValid;
};
